/* eslint-disable */
export const en = {
    'something-went-wrong': 'Something went wrong...',
    'main-page': 'Main page',
} as const;
export const ru = {
    'something-went-wrong': 'Что-то пошло не так...',
    'main-page': 'На главную',
} as const;
